import {useErrors} from "base/error/provider";
import {useNavigateWithReload} from "base/navigation/hooks";
import {PermitService} from "permit/service";
import {Spinner} from "base/shared/components";
import {ViewPermitExtensionTreesTable} from ".";

const PermitExtensionTreesContent = ({
    extension,
    displayFees = true,
    disabled = false,
}) => {
    const {handleErrors} = useErrors();
    const navigate = useNavigateWithReload();

    const handleFormSubmit = trees => {
        PermitService.extendTrees(extension?.permit?.id, trees)
            .then(response => {
                navigate("", true);
            })
            .catch(error => handleErrors(error));
    };

    return !extension ? (
        <Spinner key="spinner" />
    ) : (
        <>
            <ViewPermitExtensionTreesTable
                extension={extension}
                onSubmit={handleFormSubmit}
                displayFees={displayFees}
                disabled={disabled}
            />
        </>
    );
};

export default PermitExtensionTreesContent;
